import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useParams, Link } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@material-ui/core";
import { useDispatch } from "react-redux";
import useTranslations from "../components/Translations/useTranslations";
import { welcomeLogo as logo } from "../components/logo";
import theme from "../components/ui/theme";
import Button from "../components/ui/Buttons";
import { auth } from "../components/Auth/api";
import { auth as authPath } from "../routes/auth";
import { showSnackbar } from "../components/Snackbar/actions";
import history from "../history";

function ResetPasswordPage() {
  const trl = useTranslations();
  const dispatch = useDispatch();
  const { token, code } = useParams();

  const [is_resetting, setIsResetting] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const submitReset = (e) => {
    if (e) e.preventDefault();

    if (password !== confirmPassword) {
      return;
    }

    const missingCriteria = getPasswordErrors();
    if (missingCriteria.length > 0) {
      return;
    }

    setIsResetting(true);
    auth.resetPassword({
      token,
      code,
      password: password,
    }).then((data) => {
      setIsResetting(false);
      if (data.success) {
        dispatch(
          showSnackbar({
            label: "Votre mot de passe a été réinitialisé avec succès.",
            type: "success",
            open: true,
            delay: 10000,
          })
        );
        history.replace(authPath.LOGIN.path);
      } else {
        dispatch(
          showSnackbar({
            label: data.status_msg || "Une erreur est survenue lors de la validation du lien ou de la réinitialisation.",
            type: "error",
            open: true,
            delay: 10000,
          })
        );
      }
    }).catch((err) => {
      setIsResetting(false);
      console.error('Reset error:', err);
      dispatch(
        showSnackbar({
          label: "Une erreur est survenue lors de la réinitialisation.",
          type: "error",
          open: true,
          delay: 10000,
        })
      );
    });
  };

  const styles = {
    inputContainer: {
      ...theme.neumorphicOutset,
      borderRadius: 100,
      padding: theme.spacing(0.75),
      display: "flex",
      alignItems: "center",
    },
    input: {
      width: "100%",
      border: "none",
      backgroundColor: "transparent",
      outline: "none",
    },
  };

  const getPasswordErrors = () => {
    if (!password) return [];
    const errors = [];
    if (password.length < 8) errors.push("8 caractères minimum");
    if (!/[A-Z]/.test(password)) errors.push("une majuscule");
    if (!/[a-z]/.test(password)) errors.push("une minuscule");
    if (!/\d/.test(password)) errors.push("un chiffre");
    if (!/[\W_]/.test(password)) errors.push("un caractère spécial");
    return errors;
  };

  const renderContent = () => {
    const passwordErrors = getPasswordErrors();
    
    return (
      <form onSubmit={submitReset}>
        <div className="my-5">
          <div style={styles.inputContainer}>
            <input
              style={styles.input}
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="Nouveau mot de passe"
              required
            />
            <i
              className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
              style={{ cursor: "pointer", color: theme.primary, padding: "0 10px" }}
              onClick={() => setShowPassword(!showPassword)}
            ></i>
          </div>
          {passwordErrors.length > 0 && (
            <div className="mt-2 ml-2" style={{ color: "red", fontSize: "0.8rem", textAlign: "left" }}>
              Il manque : {passwordErrors.join(", ")}
            </div>
          )}
          <div className="mt-3" style={styles.inputContainer}>
            <input
              style={styles.input}
              onChange={(e) => setConfirmPassword(e.target.value)}
              value={confirmPassword}
              name="confirm_password"
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirmer le mot de passe"
              required
            />
            <i
              className={`fa ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}
              style={{ cursor: "pointer", color: theme.primary, padding: "0 10px" }}
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            ></i>
          </div>
          {confirmPassword.length > 0 && password !== confirmPassword && (
            <div className="mt-2 ml-2" style={{ color: "red", fontSize: "0.8rem", textAlign: "left" }}>
              Les mots de passe ne correspondent pas.
            </div>
          )}
        </div>
        <Button
          type="submit"
          block
          loading={is_resetting}
          label="Réinitialiser le mot de passe"
        />
        <Box textAlign="center" mt={3}>
          <Link to={authPath.LOGIN.path}>Se connecter</Link>
        </Box>
      </form>
    );
  };

  return (
    <React.Fragment>
      <Container>
        <Row
          style={{ height: "calc(100vh - 1.5rem)" }}
          className="justify-content-center align-items-center"
        >
          <Col md={6} lg={4}>
            <Box display="flex" justifyContent="center">
              <img className="img-fluid" src={logo} alt="Logo" />
            </Box>
            <Box mt={2}>
              <Typography variant="h6" align="center">
                {trl.message("LoginPage.title")}
              </Typography>
            </Box>
            {renderContent()}
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
}

export default ResetPasswordPage;
